import { StyleSheet } from "react-native";
import { heightPercent, widthPercent } from "../../utils";

const styles = StyleSheet.create({
  newTripContent: {
    marginTop: 25,
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 20
  },
  newTripFoto: {
    height: 60,
    width: 60,
    resizeMode: "contain",
    borderRadius: 40,
    marginHorizontal: 7,
    marginBottom: 4
  },
  inputContainer: {
    marginBottom: 16,
    marginHorizontal: 10
  },
  labelInput: {
    fontSize: 14,
    fontFamily: "Poppins",
    color: "#666666"
  },
  inputStyle: {
    textAlign: "left",
    fontSize: 14,
    fontWeight: "bold",
    color: "#666666",
    fontFamily: "Poppins",
    outlineColor: "rgba(255,255,255,0)",
    paddingLeft: 2,
    marginLeft: -2
  },
  imgContainer: {
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 5
  },
  newTripAddIcon: {
    fontSize: 60,
    color: "#f05a28",
    marginHorizontal: 7
  },
  cardMultiTrip: {
    paddingHorizontal: 14,
    paddingBottom: 11,
    paddingTop: 9,
    marginTop: 8
  },
  cardNote: {
    marginTop: 14,
    paddingHorizontal: 14,
    paddingBottom: 11,
    paddingTop: 9,
    marginBottom: 14
  },
  cardTripList: {
    paddingHorizontal: 15,
    paddingTop: 12,
    paddingBottom: 18,
    width: "50%"
  },
  cardTripListTo: {
    borderWidth: 0,
    borderTopWidth: 0,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0
  },
  titleTrip: {
    fontSize: 14,
    marginLeft: 14,
    marginBottom: 8,
    color: "#666666",
    fontFamily: "Poppins"
  },
  tripCard: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  cityName: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#50b1b1",
    marginBottom: 8
  },
  dateStyle: {
    fontSize: 14,
    color: "#50b1b1",
    fontWeight: "bold"
  },
  buttonMultiTrip: {
    marginLeft: 14
  },
  containerListCard: {
    flexDirection: "row",
    marginTop: 20,
    justifyContent: "space-between"
  },
  listCardText: {
    fontWeight: "bold",
    fontSize: 14,
    color: "#666666"
  },
  buttonAssign: {
    color: "#ed5a28",
    alignSelf: "center",
    fontSize: 11,
    fontWeight: "bold",
    fontFamily: "Poppins",
    marginTop: 5
  },
  buttonAttachmen: {
    backgroundImage:
      "linear-gradient(to bottom, #faaf40, #f05a28 63%, #db3a26)",
    borderRadius: 20
  },
  titleAttc: {
    color: "#fffff7",
    fontSize: 14,
    fontWeight: "bold",
    fontFamily: "Poppins"
  },
  saveButtonContainer: {
    marginTop: 29,
    flexDirection: "row",
    justifyContent: "center"
  },
  buttonSave: {
    width: 160,
    backgroundImage: "linear-gradient(to bottom, #50b1b1, #262261 168%)",
    borderRadius: 30,
    marginHorizontal: 10
  },
  buttonSubmit: {
    width: 160,
    backgroundImage: "linear-gradient(to bottom, #faaf40, #f05a28 63%, #db3a26)"
  },
  buttonSaveText: {
    color: "#ffffff",
    fontSize: 18,
    fontWeight: "bold",
    fontFamily: "Poppins"
  },
  datePickerNav: {
    flex: 1,
    alignItems: "center",
    height: 70,
    justifyContent: "center"
  },
  datePickerNavWrap: {
    width: 375,
    flexDirection: "row",
    borderRadius: 50,
    backgroundImage: "linear-gradient(#63a1a8, #344370)"
  },
  datePickerNavActive: {
    borderRadius: 50,
    backgroundImage: "linear-gradient(to bottom, #faaf40, #f05a28 63%, #db3a26)"
  },
  wrapSwitch: {
    flexDirection: "row",
    marginTop: 8
  },
  textSelfBooking: {
    marginRight: 12,
    fontSize: 14,
    fontFamily: "Poppins",
    color: "#666666",
    marginLeft: 5
  },
  wrapAttchSwitch: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingRight: 7
  },
  dateFrom: {
    marginBottom: 0,
    marginLeft: 0,
    paddingBottom: 0
  },
  errorAlert: {
    color: "red",
    fontFamily: "Poppins"
  },
  warningBox: {
    paddingHorizontal: 10,
    backgroundColor: "yellow",
    width: "100%"
  },
  cardChooseDestination: {
    shadowColor: "#ddd",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 2,
    marginVertical: 2,
    height: 100,
    width: "100%",
    borderRadius: 10,
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row"
  },
  containerDestinationPicker: {
    width: widthPercent(90),
    height: heightPercent(90),
    shadowColor: "#ddd",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 2,
    marginVertical: 2,
    borderRadius: 10,
    alignItems: "center",
    backgroundColor: "#fffff7",
    overflow: "scroll"
  },
  inputStyleDestinationPicker: {
    width: widthPercent(90) - 40,
    marginBottom: 10
  },
  inputTime: {
    marginTop: 10,
    height: 50,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row"
  },
  containerAutoComplete: {
    backgroundColor: "#fffff7",
    marginTop: 50,
    width: "100%",
    borderRadius: 5,
    position: "absolute",
    zIndex: 3
  },
  cardAutoComplete: {
    minHeight: 40,
    maxHeight: 120,
    overflow: "scroll",
    shadowColor: "#ddd",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 1,
    shadowRadius: 5,
    elevation: 2
  },
  headerPicker: {
    fontSize: 20,
    color: "#50B1B1",
    fontWeight: "bold",
    alignSelf: "center",
    fontFamily: "Poppins",
    marginBottom: 20,
    marginTop: 20
  },
  buttonAutoComplete: {
    width: "100%",
    height: 40,
    justifyContent: "center"
  },
  cardDate: {
    width: "100%",
    height: 40,
    justifyContent: "center"
  },
  inputDate: {
    borderWidth: 0,
    backgroundColor: "transparent",
    width: "85%"
  },
  saveDestination: {
    backgroundImage:
      "linear-gradient(to bottom, #faaf40, #f05a28 63%, #db3a26)",
    height: 54,
    width: 160,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 100
  },
  countrySelect: {
    margin: 10,
    borderWidth: 0,
    backgroundColor: "transparent",
    fontWeight: "bold",
    fontSize: 14,
    fontFamily: "Poppins",
    color: "#666666"
  },
  textValidate: {
    color: "red",
    fontSize: 12,
    fontFamily: "Poppins"
  }
});

export default styles;
